import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getTableSearchBarStyles = () => {
  return StyleSheet.create({
    inputWrapper: {
      display: 'flex',
      alignItems: 'flex-end',
      paddingBottom: tokens.spacing.SPACING_16
    }
  });
};